import { AWSService } from "./AWSService";
import { BlockService } from "./BlockService";
import { CustomElementsService } from "./CustomElementsService";
import { MediaService } from "./MediaService";
import { MicrositeService } from "./MicrositeService";
import { TemplateService } from "./TemplateService";
import { VersionHistoryService } from "./VersionHistoryService";
import {FlimpIconsService} from "./FlimpIconsService"

const Axios = {
    MicrositeService,
    MediaService,
    BlockService,
    TemplateService,
    AWSService,
    VersionHistoryService,
    FlimpIconsService,
    CustomElementsService
}

export default Axios;